import React, { useCallback } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';
import Visibility from '../../components/Visibility';
import { Image, Highlight, Description } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';



const isWebp = document.querySelector('html').classList.contains('webpSupport');
const IMAGE = isWebp ? buildImageURL('/s14-3.webp') : buildImageURL('/s14-3.jpg');

const track = getTrack({ block: 15 });

export function Portrait4() {
  const progress = useMotionValue(0);
  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed, width } }) => {
      progress.set(percentagePassed);
    },
    [progress]
  );

  const o2 = useTransform(progress, [0, 0.4], [0.2, 1]);
  const y2 = useTransform(progress, [0, 0.4], [10, 0]);
  const scale = useTransform(progress, [0, 0.4], [0.8, 1]);

  const o3 = useTransform(progress, [0.125, 0.4], [0, 1]);
  const y3 = useTransform(progress, [0.125, 0.4], ['25%', '0%']);

  return (
    <Visibility offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section section-portrait section-portrait-4 inverted" data-track={track}>
      <div className="sticky-content">
        <div className="section-content left" style={{ width: 960 }}>
          <motion.div className="picture left" style={{ opacity: o2, y: y2, scale }}>
            <Image paddingBottom="134.178%" src={IMAGE} className="s14-i-1" />
          </motion.div>
          <motion.div style={{ opacity: o3, y: y3 }}>
            <Description className="small left">
              更有蔡司 Biotar 人像风格，再现
              <br />
              梦幻镜头旋转虚化效果。
            </Description>
          </motion.div>
        </div>
      </div>
    </Visibility>
  );
}
